import { takeEvery } from 'redux-saga';
import { call, put } from 'redux-saga/effects';
import { getJSON } from '../util';

export function* checkRecaptcha({ payload: { response } }) {
    const result = yield call(getJSON, `/api/recaptcha/check?response=${response}`);

    yield put({ type: 'recaptcha:update', payload: result });
}

export function* root() {
    yield* takeEvery('recaptcha:check', checkRecaptcha);
}



// WEBPACK FOOTER //
// ./app/sagas/recaptcha.js